import BaseService from './_base.service';
export const RSSService = {
    search,
    all,
    edit,
    create,
    one,
    remove
};
function search(offset,name,title, callback) {
    let body = JSON.stringify({ name, title})
    return BaseService.post("/RSS/search/"+offset, body, callback, true)
}
function cleanBody(bodyelement) {
    const element = { ...bodyelement };
    if(element.tag && element.tag.id == -1){
        element.tag = null;
      }
    if(element.category && element.category.id == -1){
        element.category = null;
      }
    return element;
}
function edit(id, bodyelement, callback) {
    let body = JSON.stringify(cleanBody(bodyelement))
    return BaseService.put("/RSS/"+id, body, callback, true)
}
function create(bodyelement, callback) {
    let body = JSON.stringify(cleanBody(bodyelement))
    return BaseService.post("/RSS/", body, callback, true)
}
function one(id,callback) {
    return BaseService.get("/RSS/one/"+id, callback);
}
function remove(id,callback) {
    return BaseService.delete("/RSS/"+id, callback);
}
function all(callback) {
    return BaseService.get("/RSS/all/", callback);
}